















































































































import { Component, Mixins, Prop } from "vue-property-decorator";
import { mapState } from "vuex";
import { IState } from "@/store";
import { IPaymentDetail } from "@/models/paymentDetails";
import { DataModules } from "@/store/modules/data";
import { IGatewayProvider } from "@/models/gateways";

import RequestPromises from "@/mixins/requestPromises";
import Context from "@/mixins/context";
import {
  PaymentMethodType,
  SelectedPaymentMethod,
  SelectedPaymentMethodStoredCard
} from "@/models/selectPaymentMethod";
import { IClient } from "@/models/clients";
import { IBrand } from "@/models/brands";
import { UUID } from "@/data/enums";

@Component({
  computed: {
    ...mapState({
      dataScope(state: IState, getters) {
        return getters[`data/${this.dataModule}/clientScope`](this.clientId);
      },
      params(state: IState, getters) {
        return getters[`data/${this.dataModule}/params`](this.clientId);
      },
      paymentMethods(state, getters) {
        return getters[`data/listArray`]({
          storeModule: this.dataModule,
          scope: this.dataScope
        });
      }
    })
  }
})
export default class StoredPaymentMethods extends Mixins(
  RequestPromises,
  Context
) {
  @Prop({ default: null })
  public value!: SelectedPaymentMethod | null;
  @Prop({ required: true })
  public clientId!: IClient["id"];
  @Prop({ default: UUID.ORG })
  public brandId!: IBrand["id"];
  @Prop({ default: "" })
  public preselectedId!: IPaymentDetail["id"];
  @Prop({ default: true })
  public autoSelectFirst!: boolean;
  @Prop({ default: false })
  public isDisabled!: boolean;
  public paymentMethods!: IPaymentDetail[];
  public dataScope!: string;
  public dataModule = DataModules.CLIENTS_PAYMENT_DETAILS;
  // Data
  public isLoading = true;
  public requestError = false;
  public isReloading = false;

  public async created() {
    if (!this.contentAvailable) {
      this.isLoading = false;
      return;
    }
    this.getPaymentMethods();
  }

  public get filteredPaymentMethods() {
    return this.$_.filter(
      this.paymentMethods,
      pm => !this.$_.isEmpty(pm) && pm.active
    );
  }

  public get brandFilter() {
    return this.brandId !== UUID.ORG ? { brand_id: this.brandId } : {};
  }

  public reloadPaymentMethods() {
    this.isReloading = true;
    this.getPaymentMethods();
  }

  public setPaymentMethod() {
    const paymentDetails = this.$_.find(this.filteredPaymentMethods, {
      id: this.preselectedId,
      active: true
    }) as IPaymentDetail;
    if (paymentDetails) {
      this.selectMethod(paymentDetails);
      if (!this.$_.isEmpty(this.selectedMethod)) {
        return;
      }
    }
    if (!this.autoSelectFirst || !this.filteredPaymentMethods.length) {
      return;
    }

    if (this.defaultMethod) {
      this.selectMethod(this.defaultMethod);
      if (!this.$_.isEmpty(this.selectedMethod)) {
        return;
      }
    }
    const firstActive = this.$_.find(this.filteredPaymentMethods, [
      "active",
      true
    ]) as IPaymentDetail;

    if (firstActive) {
      this.selectMethod(firstActive);
    }
  }

  public async getPaymentMethods() {
    try {
      await this.$store.dispatch(`data/${this.dataModule}/list`, {
        vm: this,
        scope: this.dataScope,
        ignoreStored: true,
        id: this.clientId,
        params: {
          limit: 0,
          ...this.brandFilter,
          order: "-default,id",
          with: "gateway"
        }
      });
      this.$emit("stored-payment-methods-loaded");
      this.setPaymentMethod();
      this.requestError = false;
    } catch (error) {
      this.requestError = true;
      this.$store.dispatch("api/handleError", error);
    } finally {
      this.isLoading = false;
      this.isReloading = false;
    }
  }

  public get defaultMethod() {
    return this.$_.find(this.filteredPaymentMethods, {
      default: true,
      active: true
    }) as IPaymentDetail;
  }

  public selectMethod(paymentMethod: IPaymentDetail) {
    if (!this.$_.isEmpty(paymentMethod) && !paymentMethod.active) {
      return;
    }
    if (
      this.$_.isEmpty(paymentMethod) ||
      this.$_.get(this.selectedMethod, "id") === paymentMethod.id
    ) {
      this.paymentMethod = null;
      return;
    }

    this.paymentMethod = {
      type: PaymentMethodType.STORED_CARD,
      gatewayProviderStoreType:
        paymentMethod?.gateway?.gateway_provider?.store_type,
      data: {
        payment_details_id: paymentMethod.id,
        client_id: paymentMethod.client_id,
        address_id: paymentMethod.address_id,
        gateway_id: paymentMethod.gateway_id
      }
    } as SelectedPaymentMethodStoredCard;
  }

  public isExternalStore(gatewayProvider?: IGatewayProvider) {
    return gatewayProvider?.external_store;
  }

  public get selectedMethod() {
    return this.filteredPaymentMethods.find(
      pm => pm.id === this.$_.get(this.paymentMethod, "data.payment_details_id")
    );
  }

  public get contentAvailable() {
    return this.isClient || this.$userCan("list_client_payment_details");
  }

  public get paymentMethod() {
    return this.value;
  }

  public set paymentMethod(value) {
    this.$emit("input", value);
  }

  public beforeDestroy() {
    this.$store.dispatch("data/binList", {
      storeModule: this.dataModule,
      scope: this.dataScope,
      vm: this
    });
  }
}
